<template>
<!--  {{ category }}-->
  <confirm-modal
      @success="openPage"
      :title="$t('frames.title')"
      v-if="showPageDialog"
      @close="showPageDialog = false"
      :successButtonTitle="$t('frames.open')">
    {{ $t('frames.message') }}
  </confirm-modal>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "NewFrame",
  inheritAttrs: false,
  props: [
    'layout',
    'category',
    'isDigitalSignage',
  ],
  computed: {
    ...mapGetters({
      restURI: 'config/restURI'
    })
  },
  data() {
    return {
      showPageDialog: false,
    }
  },
  async created() {
    if (window.length > 1)
      window.history.back()
    // if (templateAttr?.value?.toLowerCase() !== 'splitview') {
    // window.location = window.history.state.back
  },
   mounted() {
     setTimeout(() => {
       let z = window.open(this.category.frameUrl, "support", "_blank")
       if (!z) {
         this.showPageDialog = true
       }
     }, 500);
  },
  methods: {
    async openPage() {
      window.open(this.category.frameUrl, "support", "_blank")
    }
  }
}


</script>
